import script from "./SyncPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncPage.vue?vue&type=script&setup=true&lang=js"

import "./SyncPage.vue?vue&type=style&index=0&id=01786e40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01786e40"]])

export default __exports__